export default __webpack_public_path__ + "static/media/08.7e1ed1b5.jpg";